import React from "react";
import {Column, Container, Wrapper} from "../../hoc/Layout";
import PrepaidTable from "../../Components/PrepaidTable";
import {FormattedMessage} from "react-intl";
import classes from "../Projects/styles.module.css";

function Prepaid() {
    return (
        <Wrapper>
            <Container style={{justifyContent: 'center'}}>
                <Column width={'100%'}>
                    <div className={classes.Card}>
                        <div className={classes.Header}>
                            <h5 className={classes.Title}>
                                <FormattedMessage
                                    id="Prepaid.title"
                                    defaultMessage="Предоплаченные карты"
                                />
                            </h5>
                        </div>

                        <div className={classes.TableWrap}>
                            <PrepaidTable/>
                        </div>
                    </div>
                </Column>
            </Container>
        </Wrapper>
    );
}

export default Prepaid;



// WEBPACK FOOTER //
// ./src/PagesOfUser/Prepaid/index.js